module.exports = __webpack_public_path__ + "img/thumb_13.686830be.jpg";